import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterRoyalascot() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-royal-ascot",
    name: "Painters Royal Ascot",
    location: "Royal Ascot, Milnerton",
    rating: 4.9,
    reviews: 162,
    specialties: ["Golf Estate Properties", "Luxury Homes", "Residential Painting", "Premium Finishes"],
    image: "https://public.readdy.ai/ai/img_res/5fa2f4f39f012ba03c577c153b138c07.jpg",
    verified: true,
    yearsExperience: 15,
    website: "https://paintersroyalascot.co.za",
    email: "info@paintersroyalascot.co.za",
    phone: "+27 21 555 0141",
    description: "Professional painting services in Royal Ascot and surrounding golf estate areas. We specialize in luxury homes and premium residential properties with expertise in high-end finishes and comprehensive property enhancement.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Golf Estate Properties",
      "Luxury Home Painting",
      "Premium Finishes & Coatings",
      "Waterproofing Services",
      "Roof Painting & Protection",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Royal Ascot", "Milnerton", "Century City", "Table View", "Parklands", "Sunningdale", "Northern Suburbs"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Royal%20Ascot%20golf%20estate%2C%20modern%20luxury%20home%20with%20fresh%20walls%20and%20golf%20course%20views%2C%20quality%20paint%20finish%2C%20Table%20Mountain%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20elegant%20furniture%20and%20premium%20decor&width=400&height=300&seq=royalascot-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Royal%20Ascot%20Milnerton%20Cape%20Town%20South%20Africa%2C%20luxury%20golf%20estate%20home%20with%20fresh%20paint%20overlooking%20fairways%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20prestigious%20setting%20with%20mountain%20views%2C%20well-maintained%20property%20with%20beautiful%20landscaping&width=400&height=300&seq=royalascot-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Luxury%20home%20painting%20project%20in%20Royal%20Ascot%20golf%20estate%2C%20professional%20painters%20working%20on%20upscale%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20modern%20elegant%20architecture%20with%20golf%20course%20views%2C%20organized%20work%20site%20with%20painting%20equipment%20and%20materials&width=400&height=300&seq=royalascot-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Royal%20Ascot%20luxury%20home%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20modern%20gourmet%20kitchen%2C%20quality%20paint%20finish%20with%20sophisticated%20color%20scheme%2C%20bright%20clean%20space%20with%20golf%20course%20views%2C%20professional%20painting%20work%20with%20contemporary%20fixtures%20and%20high-end%20appliances&width=400&height=300&seq=royalascot-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20interior%20painting%20in%20Royal%20Ascot%20golf%20estate%20home%2C%20fresh%20painted%20walls%20in%20elegant%20bedroom%2C%20modern%20luxury%20design%20with%20fairway%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20premium%20decor%20and%20natural%20lighting&width=400&height=300&seq=royalascot-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20luxury%20home%20painting%20in%20Royal%20Ascot%20Milnerton%20Cape%20Town%2C%20professional%20painters%20applying%20premium%20paint%20to%20golf%20estate%20property%2C%20Table%20Mountain%20and%20fairway%20backdrop%2C%20quality%20exterior%20finish%20with%20weather%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment&width=400&height=300&seq=royalascot-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Robert Henderson",
        rating: 5,
        comment: "Exceptional work on our Royal Ascot home! The team delivered a flawless finish that perfectly complements our property's luxury aesthetic. Their attention to detail and professionalism exceeded all expectations."
      },
      {
        name: "Catherine Botha", 
        rating: 5,
        comment: "Professional service from start to finish. They completed our golf estate home painting on schedule and the quality is outstanding. The premium finishes have held up beautifully and we couldn't be happier."
      },
      {
        name: "Michael Stevens",
        rating: 5,
        comment: "Outstanding attention to detail and very experienced with luxury properties. Our home looks absolutely stunning and we've received numerous compliments from neighbors and guests at the estate."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Royal Ascot | Professional Golf Estate & Luxury Home Painting Milnerton | Premium Painting Services";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Royal Ascot offers professional painting services for golf estate properties and luxury homes in Royal Ascot, Milnerton. Specializing in premium finishes, high-end residential painting, and comprehensive property enhancement. Expert luxury painting contractors.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Royal Ascot, house painters Royal Ascot, golf estate painting contractors, luxury home painting Milnerton, premium painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20luxury%20golf%20estate%20home%20in%20Royal%20Ascot%20Milnerton%20Cape%20Town%20South%20Africa%2C%20spectacular%20Table%20Mountain%20views%20with%20manicured%20fairways%2C%20painters%20in%20clean%20uniforms%20applying%20paint%20with%20brushes%20and%20rollers%2C%20modern%20elegant%20architecture%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment%20and%20prestigious%20golf%20estate%20setting&width=1200&height=600&seq=royalascot-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters Royal Ascot
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Expert Golf Estate & Luxury Home Painting Services
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Royal Ascot's most trusted painting contractors specializing in golf estate properties and luxury homes. With over 15 years of experience serving prestigious residential estates, we deliver exceptional quality and sophistication using premium materials and advanced techniques designed to enhance and protect high-end properties in this exclusive community.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters Royal Ascot</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters Royal Ascot, the premier painting contractor for luxury residential properties and golf estate homes in one of Cape Town's most prestigious communities. For over 15 years, we have been the trusted choice for discerning homeowners throughout Royal Ascot, Milnerton, Century City, and the surrounding Northern Suburbs who demand superior craftsmanship, premium finishes, and exceptional service for their high-end properties.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been built on a solid foundation of exceptional quality workmanship, meticulous attention to detail, and an unwavering commitment to customer satisfaction. We understand that owning a property in Royal Ascot represents a significant investment and lifestyle choice, and we have developed specialized expertise in delivering painting services that enhance property value, aesthetic appeal, and long-term durability while meeting the exacting standards expected in this exclusive golf estate community.
                        </p>
                        <p className="leading-relaxed">
                          What truly distinguishes Painters Royal Ascot from other painting contractors is our deep understanding of the specific requirements and expectations associated with luxury golf estate properties. The combination of architectural sophistication, premium materials, high aesthetic standards, and the need for minimal disruption to residents' lifestyles requires specialized knowledge, advanced techniques, and proven project management capabilities. Our team has spent years perfecting our methods to ensure that every project we complete not only looks stunning but also provides maximum protection and longevity while respecting the exclusive character of the Royal Ascot community.
                        </p>
                        <p className="leading-relaxed">
                          We take immense pride in our comprehensive, detail-oriented approach to every painting project. From the moment you contact us for an initial consultation through to the final walk-through inspection, we maintain the highest professional standards at every stage. Our process begins with a thorough assessment of your property's condition, taking into account factors such as existing paint condition, substrate type, architectural features, aesthetic preferences, and any specific concerns you may have. We then provide detailed recommendations and a transparent, itemized quote with no hidden costs or surprises.
                        </p>
                        <p className="leading-relaxed">
                          Our team of skilled painters are not simply workers applying paint to surfaces; they are experienced craftsmen who take genuine pride in their work and understand the importance of delivering flawless results that meet the exacting standards of luxury property owners. Each team member has been carefully selected for their skills, reliability, professionalism, and commitment to excellence. We invest heavily in ongoing training to ensure our team stays current with the latest techniques, premium products, and industry best practices, including specialized training in luxury home finishing and estate property maintenance.
                        </p>
                        <p className="leading-relaxed">
                          Over the years, we have built an impressive portfolio of completed projects throughout the Royal Ascot golf estate and surrounding prestigious communities. From elegant family homes and luxury villas to contemporary architectural masterpieces and classic estate properties, we have successfully completed hundreds of projects of varying sizes and complexity. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of its scope. We treat every home as if it were our own, ensuring that the final result exceeds your expectations and enhances your property's value and appeal.
                        </p>
                        <p className="leading-relaxed">
                          At Painters Royal Ascot, we believe in building long-term relationships with our clients based on trust, transparency, and consistently excellent results. Many of our customers have been with us for years, returning for maintenance work, renovations, and new projects. They recommend us to their friends, family, and neighbors within the estate because they know they can rely on us to deliver superior quality, honest advice, fair pricing, and the discretion and professionalism expected in an exclusive community every single time. This loyalty and trust is something we never take for granted, and it drives us to maintain our high standards on every project.
                        </p>
                        <p className="leading-relaxed">
                          Our commitment to excellence extends far beyond the quality of our painting work. We understand that having contractors working in and around your luxury home requires a high level of trust, professionalism, and discretion. That's why we maintain clean, organized work sites, protect your furniture and belongings with premium materials, respect your property and privacy, work efficiently to minimize disruption to your daily routine, and ensure our team members conduct themselves with the professionalism expected in an exclusive golf estate community. We communicate clearly and regularly throughout the project, keeping you informed of progress and addressing any questions or concerns promptly.
                        </p>
                        <p className="leading-relaxed">
                          We use only premium, environmentally responsible paints and materials from leading international and local manufacturers such as Plascon, Dulux, Resene, and specialized luxury coating suppliers. These products are specifically formulated to provide superior adhesion, durability, aesthetic appeal, and resistance to environmental factors. By investing in the best materials available, we ensure that your paint job not only looks stunning on completion day but continues to look great and provide protection for many years to come, maintaining the premium appearance expected in the Royal Ascot golf estate.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters Royal Ascot?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">15+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Over a decade and a half of proven excellence in luxury home and golf estate property painting.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind and protection.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-star-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Premium Materials</h4>
                            <p className="text-gray-600 text-sm">We exclusively use premium paints and coatings from leading manufacturers for superior results and longevity.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Exceptional Service</h4>
                            <p className="text-gray-600 text-sm">Professional communication, respect for your property, and commitment to exceeding expectations.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters Royal Ascot proudly serves the Northern Suburbs and surrounding prestigious areas, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Royal Ascot', 'Milnerton', 'Century City', 'Table View', 'Parklands', 'Sunningdale', 'Bloubergstrand', 'Big Bay', 'West Beach'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters Royal Ascot, we offer a complete range of professional painting services specifically designed for luxury homes and golf estate properties. Our expertise encompasses every aspect of high-end residential painting, from initial consultation and color selection through to meticulous surface preparation, expert application, and thorough final inspection.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Luxury Interior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your living spaces with our premium interior painting services. We specialize in creating beautiful, sophisticated finishes that enhance your home's aesthetic appeal and value. Our meticulous surface preparation and expert application techniques ensure flawless results in every room.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living rooms, bedrooms, and entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Gourmet kitchens and luxury bathrooms</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, cornices, and architectural features</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Custom finishes and designer color schemes</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-building-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Premium Exterior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Protect and enhance your property's exterior with our specialized luxury home painting services. We use premium paints and advanced application techniques specifically designed to provide superior protection and aesthetic appeal. Our comprehensive approach includes thorough surface preparation and protective coatings.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior walls with premium protective coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Windows, doors, and architectural trim</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Decks, patios, and outdoor entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Fascias, soffits, and decorative elements</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-drop-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Waterproofing & Protection</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Essential for maintaining property value, our comprehensive waterproofing services protect your investment from water damage, mold growth, and structural deterioration. We use advanced waterproofing systems and sealants specifically designed for luxury properties.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior wall waterproofing and sealing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Roof waterproofing and protective coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Balcony and deck waterproofing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Damp proofing and moisture barrier installation</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-paint-brush-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Specialty Finishes</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Enhance your property with our range of specialty coatings and decorative finishes. From UV-resistant clear coats to textured finishes and custom color matching, we have the expertise and experience to create unique, stunning results that reflect your personal style.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant protective clear coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Textured and decorative wall finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Wood staining, sealing, and varnishing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Custom color matching and design consultation</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20luxury%20golf%20estate%20home%20in%20Royal%20Ascot%20Milnerton%2C%20Table%20Mountain%20and%20fairway%20views%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20modern%20elegant%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=royalascot-sidebar-image&orientation=landscape"
                    alt="Professional painters Royal Ascot golf estate luxury home painting services Milnerton Cape Town"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
